export default "assets/images/logo-black-d8b92af1.png";